import React from "react";
import LinkListPage from "@/components/institute/LinkListPage";

export default function InstituteLinks() {
  return (
    <LinkListPage
      eyebrow="Resources"
      title="Important Links"
      subtitle="Public-facing references — circulars, approvals, forms, and external resources. Each link has a name, an active/inactive status, and either an attached PDF (max 5 MB) or an external URL."
      listUrl="/institute/links"
      mutateBaseUrl="/institute/links"
      testidPrefix="inst-links"
      itemNoun="Link"
      uploadKind="inst_link_pdf"
    />
  );
}
